// extracted by mini-css-extract-plugin
export default {"item-list":"BeersMobile_item-list__F11Fd","item":"BeersMobile_item__voAOP","section":"BeersMobile_section__173ut","category-title":"BeersMobile_category-title__0AF3l"};